module.exports = __webpack_public_path__ + "static/img/page_16.2eeb770e.png";